import { render, staticRenderFns } from "./UserManagerPopUp.vue?vue&type=template&id=2b611736&scoped=true&"
import script from "./UserManagerPopUp.vue?vue&type=script&lang=js&"
export * from "./UserManagerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UserManagerPopUp.vue?vue&type=style&index=0&id=2b611736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b611736",
  null
  
)

export default component.exports